import { Button, ForwardedColumn, Row } from 'hatch-components';
import styled from 'styled-components';

export const CONFIRM_MENU_WIDTH = 305;
export const DEFAULT_CONFIRM_MENU_HEIGHT = 170;

export const StyledConfirmMenu = styled(ForwardedColumn)(
  ({
    transition,
    theme: {
      colors,
      border,
      shadows,
      responsive: { mobile },
    },
    targetRef,
    showOnMobile,
  }) => {
    const {
      top = 0,
      left = 0,
      height = 0,
    } = targetRef?.current?.getBoundingClientRect() ?? {};
    const offset = 12;

    const topPosition = `${
      top + height / 2 - DEFAULT_CONFIRM_MENU_HEIGHT / 2
    }px`;
    const leftPosition = `${left - CONFIRM_MENU_WIDTH - offset}px`;

    return {
      background: colors.white,
      border: `1px solid ${colors.disabled}`,
      borderRadius: border.radius.md,
      boxShadow: shadows.primary,
      left: leftPosition,
      [mobile]: {
        display: showOnMobile ? 'flex' : 'none',
        left: '50%',
        marginLeft: `-${CONFIRM_MENU_WIDTH / 2}px`,
      },
      opacity: transition === 'entered' ? 1 : 0,
      padding: '14px 16px',
      position: 'fixed',
      top: topPosition,
      transition: 'opacity 0.25s ease',
      width: CONFIRM_MENU_WIDTH,
      zIndex: 9999,
    };
  },
);

export const StyledButtonWrapper = styled(Row)(
  ({ extraMargin, theme: { spacing } }) => ({
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: extraMargin ? spacing.sm : spacing.xs,
    padding: `0 ${spacing.xs}`,
    width: '100%',
  }),
);

export const StyledActionButton = styled(Button)(
  ({ theme: { font, colors, spacing } }) => ({
    '&:hover': {
      backgroundColor: colors.errorHighlight,
    },
    backgroundColor: colors.error,
    flexGrow: 0,
    flexShrink: 0,
    fontWeight: font.weight.bold,
    height: 36,
    minHeight: 36,
    minWidth: '90px',
    padding: `0 ${spacing.sm}`,
    width: 'auto',
  }),
);

export const StyledConfirmCancelButton = styled(Button)(
  ({ theme: { font, colors, spacing } }) => ({
    '&:hover': {
      textDecoration: 'underline',
    },
    borderRadius: 0,
    color: colors.lavender,
    flexGrow: 0,
    flexShrink: 0,
    fontWeight: font.weight.normal,
    padding: `${spacing.xxs} 0`,
    width: '50px',
  }),
);

export const StyledConfirmTitle = styled.h1(
  ({ theme: { font, spacing, colors } }) => ({
    color: colors.text.primary,
    display: 'block',
    fontSize: font.size.md,
    fontWeight: font.weight.bold,
    lineHeight: font.lineHeight.md,
    padding: `0 ${spacing.xs}`,
    width: '100%',
  }),
);

export const StyledConfirmSubtitle = styled.h2(
  ({ theme: { font, spacing, colors } }) => ({
    color: colors.text.primary,
    display: 'block',
    fontSize: font.size.sm,
    fontWeight: font.weight.normal,
    lineHeight: font.lineHeight.md,
    padding: `6px ${spacing.xs}`,
  }),
);

export const StyledLabel = styled.label(
  ({ error, theme: { colors, font, spacing } }) => ({
    color: error ? colors.error : colors.grey,
    cursor: 'pointer',
    display: 'block',
    fontSize: font.size.sm,
    fontWeight: font.weight.normal,
    lineHeight: font.lineHeight.sm,
    marginTop: spacing.xxs,
    padding: `6px ${spacing.xs}`,
  }),
);
